<script setup>
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import PremiumTabs from '@/Components/PremiumTabs.vue';
import { ref, computed, watch } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head, useForm, usePage } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import Buttons from "@/Components/Buttons.vue";
import { Icon } from '@iconify/vue';
import {
    mdiArrowULeftTopBold,
    mdiHomeSearch,
    mdiCradle,
    mdiPuzzleRemove,
    mdiTownHall,
    mdiCross,
    mdiPill,
    mdiMedicalBag,
    mdiGymnastics,
    mdiWater,
    mdiCheckDecagram,
    mdiCreditCardOutline, mdiPlusCircle, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiMail
} from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableAdvancedFilter from "@/Components/TableAdvancedFilter.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import { Inertia } from '@inertiajs/inertia';
// Breeze
import BreezeButton from '@/Components/Button.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import BaseIcon from "@/Components/BaseIcon.vue";

import FormField from "@/Components/FormField.vue";
import FormControl from "@/Components/FormControl.vue";
import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBoxCiclo from "@/Components/CardBoxCiclo.vue";
import RadarChart from "@/Components/Charts/RadarChart.vue";
import TableSingle from "@/Components/TableSingle.vue";

/* - LRR defineProps({
    //students: Array,
    //columnas: Array,
    object: Object
});
*/
const props = defineProps({
    //students: Array,
    //columnas: Array,
    actioncontrol: {
        type: String,
        default: 'view'
    },
    object: Object,
    typeDocuments: Object,
    distritos: Object,
    afps: Object,
    puestolaborales: Object,
    estadoCiviles: Object,
    situationeducations: Object,
    chartCompetencias: Object,
    levels: Object,
    classrooms: Object,
    classroomsTeorico: Object,
    roles: Object,
    user: Object,
    rightsCatalog: {
        type: Array,
        default: () => []
    },
    userDirectRights: {
        type: Array,
        default: () => []
    },
    userRoleRights: {
        type: Array,
        default: () => []
    },
    courses: Object,
    collaborator_courses: Object,
    classrooms_courses: Object,
    isAdmin: Boolean,
    collabIsCoord: Boolean,
    entidades: Array,
    collaboratorturns: Object,
    debugInertia: Boolean,
    sedes: Object
});

//console.log(props.object)
/* LRR
{
start: '2018-11-19 12:00', // Required.
end: '2018-11-19 14:00', // Required.
// Instead of formatted dates, you can also provide Javascript Date objects:
// start: new Date(2018, 11 - 1, 19, 12, 0),
// end: new Date(2018, 11 - 1, 19, 14, 0),
title: {String}, // Optional.
content: {String}, // Optional.
class: {String}, // Optional - space-separated css classes.
background: {Boolean} // Optional. (Event type not CSS property)
split: {Number|String} // Optional.
allDay: {Boolean} // Optional.
deletable: false // optional - force undeletable when events are editable.
resizable: false // optional - force unresizable when events are editable.
}
*/
const events = [
    { id: 1, start: '2022-12-05 12:00', end: '2022-12-06 12:00', title: 'Más trabajo, está bien', content: 'es mejor que halla más trabajo', deletable: 1 },
    { id: 2, start: '2022-12-07 12:00', end: '2022-12-07 13:00', title: 'Más trabajo, está bien', content: 'es mejor que halla más trabajo', split: 1 },
    { id: 3, start: '2022-12-08 12:00', end: '2022-12-08 13:00', title: 'Más trabajo, está bien', content: 'es mejor que halla más trabajo', allday: 1 },
    { id: 4, start: '2022-12-08 16:00', end: '2022-12-08 18:00', title: 'Más trabajo, está bien', content: 'es mejor que halla más trabajo', resizable: 1 }
]

const notas = {
    "files": [
        { "id": 1, "course": "Geometría", "maestro": "Lenin Rivas", "progress": 71 },
        { "id": 2, "course": "Lenguaje", "maestro": "Lucy Farroñay", "progress": 68 },
        { "id": 3, "course": "Arte", "maestro": "Jorge el Curioso", "progress": 49 },
        { "id": 3, "course": "Sociedad y Ambiente", "maestro": "Dora la Exploradora", "progress": 36 },

    ]
};

//console.log(props.typeDocuments)
// Carga de objeto
const rutaPrefijo = ref('collaborator')
const modulo = ref('Colaborador')
const modulos = ref('Colaboradores')
//const action = ref('view')
const action = ref(props.actioncontrol) // Los props son de lectura así que en el template se haré cambios al action segúnn el click a cada boton

const tab = ref(0)

const page = usePage()

const tabsMenu = computed(() => [
    { id: 0, label: 'Ficha', icon: 'tabler:user', show: true },
    { 
        id: 1, 
        label: 'Cursos', 
        icon: 'tabler:book', 
        show: props.object && props.object.person && props.object.person.user ? (props.object.person.user.id_rol != 5) : false 
    },
    { id: 2, label: 'Aulas/Asig.', icon: 'tabler:brand-google-meetup', show: true },
    { id: 3, label: 'Turnos de asistencia', icon: 'tabler:calendar-event', show: props.isAdmin },
    { id: 4, label: 'Permisos', icon: 'tabler:shield-lock', show: page.props.value.auth.user.id_rol <= 3 || page.props.value.auth.collaborator.right('permisos', 'read') },
    { id: 10, label: 'Agenda', icon: 'tabler:calendar-time', show: page.props.value.auth.user.id_rol <= 5 }
]);

/* watch(tab, (newTab) => {
    if (newTab === 0) {
        action.value = 'view';
    }
}); */

console.log('Hola actioncontrol inicial: ' + props.actioncontrol)
watch(() => props.actioncontrol, (newAction) => {
    console.log('Hola actioncontrol con watch: ' + newAction)
    action.value = newAction;
});

// deshabilitar o habilitar
const initModal = (action) => {
    let ruta = rutaPrefijo.value + '-' + action
    Inertia.put(route(ruta, {
        'id': props.object.id,
    }
    ))

}

const form = useForm({
    id: props.object ? props.object.id : 0,
    // Persona
    apellidos: props.object ? props.object.person.apellidos : '',
    nombres: props.object ? props.object.person.nombres : '',
    id_type_document: props.object ? props.object.person.id_type_document : 1,// 1 DNI
    num_doc: props.object ? props.object.person.num_doc : '',
    domicilio: props.object ? props.object.person.domicilio : '',
    sexo: props.object ? props.object.person.sexo : 0,
    id_distrito_domicilio: props.object ? (props.object.person.id_distrito_domicilio ?? null) : null,// Sedeje documento que es posible hacer esto
    referencia: props.object ? props.object.person.referencia : '',
    fecha_nacimiento: props.object ? props.object.person.fecha_nacimiento : '',
    id_distrito_nacimiento: props.object ? props.object.person.id_distrito_nacimiento : null,// Pero se toma null par ambos casos de crear o editar que sea vacío
    telefono: props.object ? props.object.person.telefono : '',
    celular: props.object ? props.object.person.celular : '',
    email: props.object ? props.object.person.email : '',

    // Colaborador
    vivienda: props.object ? props.object.vivienda : null,
    id_situation_education: props.object ? props.object.id_situation_education : null,
    id_puesto_laboral: props.object ? props.object.id_puesto_laboral : null,
    fecha_inicio_laboral: props.object ? props.object.fecha_inicio_laboral : '',
    id_afp: props.object ? props.object.id_afp : null,
    cuenta_bancaria: props.object ? props.object.cuenta_bancaria : '',
    seguro: props.object ? props.object.seguro : '',
    recurso_prestado: props.object ? props.object.recurso_prestado : '',
    note: props.object ? props.object.note : '',
    status: props.object ? props.object.status : 1,
    entity: props.object ? props.object.entity : 0,

    salario: props.object ? props.object.salario : 0,
    tipo_jornal: props.object ? props.object.tipo_jornal : 1,
    empleado: props.object ? (props.object.empleado ? 1 : 0) : 1,

    // User
    user_status: props.user ? props.user.status : 0,
    //user_email: props.object ? props.object.user_email : null,
    //password: props.object ? props.object.password : null,
    //password_confirmation: props.object ? props.object.password_confirmation : null,
    id_rol: props.user ? props.user.id_rol : null,
    //rol_type: props.object ? props.object.rol_type : null,
    view_course_formacion: props.user ? (props.user.view_course_formacion ? 1 : 0) : 0,
    sede_origen: props.object ? props.object.sede_origen : null,
    change_password: 0,
    enable_token: 0
});

const rightsForm = useForm({
    id: props.object ? props.object.id : 0,
    rights: [...(props.userDirectRights || [])]
});

const isRoleInheritedRight = (rightId) => {
    return (props.userRoleRights || []).includes(rightId);
};

const isDirectCheckedRight = (rightId) => {
    return rightsForm.rights.includes(rightId);
};

const isRightActive = (rightId) => {
    return isRoleInheritedRight(rightId) || isDirectCheckedRight(rightId);
};

const toggleDirectRight = (rightId) => {
    if (isRoleInheritedRight(rightId)) return;
    const index = rightsForm.rights.indexOf(rightId);
    if (index > -1) {
        rightsForm.rights.splice(index, 1);
    } else {
        rightsForm.rights.push(rightId);
    }
};

const groupedRightsCatalog = computed(() => {
    const familiesMeta = {
        'menu': { title: 'Permisos Globales (Menú Principal)', icon: 'tabler:layout-grid' },
        'permisos': { title: 'Gestión de Permisos', icon: 'tabler:shield-check' },
        'agenda': { title: 'Agenda y Eventos', icon: 'tabler:calendar-event' },
        'comunicados': { title: 'Comunicados Oficiales', icon: 'tabler:speakerphone' },
        'cursos': { title: 'Cursos de Formación (Libres)', icon: 'tabler:certificate' },
        'simulacro': { title: 'Simulacros de Admisión', icon: 'tabler:school' },
        'financial': { title: 'Área Financiera', icon: 'tabler:wallet' },
        'rrhh': { title: 'Recursos Humanos y Asistencias', icon: 'tabler:users-group' },
    };

    const familyOrder = ['menu', 'permisos', 'agenda', 'comunicados', 'cursos', 'simulacro', 'financial', 'rrhh'];
    const groups = {};

    // Inicializar en el orden estricto deseado
    familyOrder.forEach(fKey => {
        groups[fKey] = {
            title: familiesMeta[fKey]?.title || fKey.toUpperCase(),
            icon: familiesMeta[fKey]?.icon || 'tabler:folder',
            items: []
        };
    });

    (props.rightsCatalog || []).forEach(r => {
        const fKey = r.family || 'otros';
        if (!groups[fKey]) {
            groups[fKey] = {
                title: familiesMeta[fKey]?.title || fKey.toUpperCase(),
                icon: familiesMeta[fKey]?.icon || 'tabler:folder',
                items: []
            };
        }
        groups[fKey].items.push(r);
    });

    // Filtrar grupos vacíos manteniendo el orden
    const orderedResult = {};
    Object.keys(groups).forEach(key => {
        if (groups[key].items.length > 0) {
            orderedResult[key] = groups[key];
        }
    });

    return orderedResult;
});

const saveRights = () => {
    rightsForm.put(route('collaborator-rights-actualizar'), {
        preserveScroll: true,
    });
};

/**
 * 
 * LRR 
 * Incializar valorres
 */


// Usar objecto de 
/*const json = '{"result":true, "count":42}';
const obj = JSON.parse(json);
Y
console.log(JSON.stringify({ x: 5, y: 6 }));
// expected output: "{"x":5,"y":6}"

console.log(JSON.stringify([new Number(3), new String('false'), new Boolean(false)]));
// expected output: "[3,"false",false]"

console.log(JSON.stringify({ x: [10, undefined, function(){}, Symbol('')] }));
// expected output: "{"x":[10,null,null,null]}"

console.log(JSON.stringify(new Date(2006, 0, 2, 15, 4, 5)));
// expected output: ""2006-01-02T15:04:05.000Z""

//const objVivienda[{"attribute_type_id":"5024","description":"Asientos","value":"20","start_date":null,"end_date":null,"duration":null}]
*/

// LRR un simple array para usar sólo option del componente input

const optionsGenero = [
    { id: 0, label: 'Femenino' },
    { id: 1, label: 'Masculino' },
]

const optionsJornal = [
    { id: 1, label: 'Completo' },
    { id: 2, label: 'Parcial' },
]

/* const optionsTamizaje = [
    {id: 0, label: 'Pendiente con compromiso'},
    {id: 1, label: 'Realizado y entregado'},
] */


// Seguro de salud
const optionsSeguroSalud = [
    'Particular',
    'ESSALUD',
    'SIS',
    'Otro',
    'No tiene',
]
const selectSeguroSalud = ref('')
const textSeguroSalud = ref('')
if (props.object && props.object.seguro) {
    let arraySeguroSalud = props.object.seguro.split(' :')
    selectSeguroSalud.value = arraySeguroSalud[0]
    if (arraySeguroSalud[1]) textSeguroSalud.value = arraySeguroSalud[1]
} else {
    selectSeguroSalud.value = optionsSeguroSalud[3]// <-- Selección por defecto al crear
}

// Situación familiar
/* const optionsSituacionFamiliar = [
    'Sus 2 padres y hermanos',
    'Sólo con su mamá',
    'Sólo con su papá',
    'Con otros familiares',
]
const selectSituacionFamiliar = ref('')
const textSituacionFamiliar = ref('')
if (props.object && props.object.obs_situacion_familiar) {
    let arraySituacionFamiliar = props.object.obs_situacion_familiar.split(' : ')
    selectSituacionFamiliar.value = arraySituacionFamiliar[0]
    if (arraySituacionFamiliar[1]) textSituacionFamiliar.value = arraySituacionFamiliar[1]  
} */

// Vivienda
const optionsVivienda = [
    'Casa propia',
    'Casa alquilada',
    'Casa de otros familiares',
    'Casa alquilada',
    'Otro'
]

const selectVivienda = ref('')
const textVivienda = ref('')
if (props.object && props.object.vivienda) {
    let arrayVivienda = props.object.vivienda.split(' :')// <-- ' : ' No se guarda el espacio despues del punto
    selectVivienda.value = arrayVivienda[0]
    if (arrayVivienda[1]) textVivienda.value = arrayVivienda[1]
    /* if (arrayVivienda.length > 1) {
        selectVivienda.value = arrayVivienda[0]
        textVivienda.value = arrayVivienda[1]
    } else {
        let result = props.object.obs_datos_vivienda.replace(' : ', '')
        optionsVivienda.includes(result) ? selectVivienda.value = result : textVivienda.value = result
    } */
} else {
    selectVivienda.value = optionsVivienda[4]// <-- Selección por defecto al crear
}

// Acesso al sistema? // usar user status
//const accesoLogin = ref(0)

// Crear o actualizar
const submit = () => {
    if (action.value == 'create') {
        form.post(route(rutaPrefijo.value + '-registrar'), {
            //onFinish: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
            onSuccess: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
        });
    } else if (action.value == 'edit') {
        form.put(route(rutaPrefijo.value + '-actualizar'), {
            onSuccess: () => action.value = 'view',
            onFinish: () => form.reset('apellidos, nombres, email, telefono, celular, obs_aprendizaje'),
        });
    }

};

const showNotas = ref([])

//const cancel = () => {
//if (rutaPrefijo.value=='student') {
//form.obs_aprendizaje = '';
//}
//}

//console.log(props.object)

/* const refreshList = (action) => {
    if (action == 'object') {
        Inertia.reload({ only: ['object']})
    } else if (action == 'curso') {
        Inertia.reload({ only: ['curso']})
    }
} */
</script>

<template>

    <Head :title="object ? object.person.apellidos + ' ' + object.person.nombres : 'Nuevo colaborador'" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PremiumPageHeader 
                :title="action === 'create' ? 'Nuevo colaborador' : (action === 'edit' ? 'Modificar Colaborador' : 'Ficha del Colaborador')" 
                :subtitle="action === 'create' ? 'Registrar un nuevo colaborador en el sistema' : (action === 'edit' ? 'Editar la información del colaborador' : 'Visualización detallada del perfil del colaborador')"
                icon="tabler:user"
                color="indigo"
                :actionsOnBottomOnMobile="false"
            >
                <template #actions>
                    <Buttons :href="route('collaborator-list')" size="vuexy" icon="tabler:arrow-left" label="Volver al listado" color="light" :hideLabelOnMobile="true"/>
                </template>
                <template v-slot:bottom>
                    <PremiumTabs v-if="action !== 'create'" v-model="tab" :tabs="tabsMenu" />
                </template>
            </PremiumPageHeader>
        </template>
        <div>
            <template v-if="(tab == 0)">
                <!-- Ficcha colaborador -->
                <!-- Action View-->
                <template v-if="action == 'view' || action == ''">
                    <!-- Collaborator Profile Card Details View -->
                    <div class="space-y-6">
                        <!-- Profile Header Banner -->
                        <div class="relative overflow-hidden bg-white border border-b-4 border-b-rose-600 rounded-2xl shadow-lg p-6 text-white">
                            <!-- Background decorative circles -->
                            <div class="absolute -right-10 -top-10 w-40 h-40 bg-white/10 rounded-full blur-xl pointer-events-none"></div>
                            <div class="absolute right-20 bottom-[-50px] w-52 h-52 bg-white/10 rounded-full blur-2xl pointer-events-none"></div>

                            <div class="flex flex-col md:flex-row items-center gap-6 relative z-10">
                                <!-- Avatar -->
                                <!-- <div class="relative shrink-0">
                                    <img class="w-24 h-24 rounded-2xl border-4 border-white/20 shadow-2xl object-cover bg-white"
                                         :src="object.person.sexo ? '/img/student/boy.png' : '/img/student/girl.png'"
                                         alt="Avatar" />
                                    <span class="absolute -bottom-2 -right-2 w-8 h-8 rounded-full border-4 border-indigo-700 flex items-center justify-center shadow-lg animate-pulse"
                                          :class="object.status ? 'bg-emerald-500' : 'bg-rose-500'"
                                          :title="object.status ? 'Empleado Activo' : 'Empleado Inactivo'">
                                        <Icon :icon="object.status ? 'tabler:check' : 'tabler:x'" class="w-4 h-4 text-white" />
                                    </span>
                                </div> -->

                                <!-- Main Details -->
                                <div class="text-center md:text-left flex-1 space-y-2">
                                    <div class="flex flex-wrap items-center justify-center md:justify-start gap-2.5">
                                        <h1 class="text-2xl lg:text-3xl font-extrabold tracking-tight">
                                            {{ object.person.apellidos }} {{ object.person.nombres }}
                                        </h1>
                                        <span class="px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider backdrop-blur-md">
                                            {{ object.id_puesto_laboral ? puestolaborales.find(item => item.id === object.id_puesto_laboral)?.label : 'Puesto no asignado' }}
                                        </span>
                                        <span v-if="object.entity && entidades && entidades.length > 0" class="px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider ">
                                            {{ entidades.find(item => item.id === object.entity)?.label || 'Entidad ' + object.entity }}
                                        </span>
                                    </div>
                                    <p class="text-gray-700 text-sm flex flex-wrap items-center justify-center md:justify-start gap-x-4 gap-y-1">
                                        <span class="flex items-center gap-1.5">
                                            <Icon icon="tabler:id-badge" class="w-4 h-4 text-rose-600" />
                                            <span>Código: {{ object.ref || '-' }}</span>
                                        </span>
                                        <span class="flex items-center gap-1.5">
                                            <Icon icon="tabler:mail" class="w-4 h-4 text-rose-600" />
                                            <span>{{ object.person.email || '-' }}</span>
                                        </span>
                                        <span class="flex items-center gap-1.5">
                                            <Icon icon="tabler:phone" class="w-4 h-4 text-rose-600" />
                                            <span>{{ object.person.celular || object.person.telefono || '-' }}</span>
                                        </span>
                                    </p>
                                </div>

                                <!-- Action Buttons Header -->
                                <div class="flex flex-row md:flex-col lg:flex-row items-center gap-3 w-full md:w-auto mt-4 md:mt-0 shrink-0">
                                    <Buttons color="yellow" size="vuexy" icon="tabler:pencil" @click="action = 'edit'"
                                             label="Modificar" class="w-full md:w-auto" />
                                    
                                    <Buttons v-if="object.status" color="red" size="vuexy" icon="tabler:circle-x"
                                             @click="initModal('desactivar')" label="Deshabilitar" class="w-full md:w-auto" />
                                    <Buttons v-else color="green" size="vuexy" icon="tabler:check"
                                             @click="initModal('activar')" label="Habilitar" class="w-full md:w-auto" />
                                </div>
                            </div>
                        </div>

                        <!-- Info Grid Details -->
                        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
                            <!-- Card 1: Datos Personales & Contacto -->
                            <div class="bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-3xl shadow-sm p-6 space-y-6">
                                <div class="flex items-center gap-3 border-b border-slate-100 dark:border-slate-800 pb-3">
                                    <div class="p-2 bg-sky-50 dark:bg-sky-950/30 rounded-xl text-sky-600 dark:text-sky-400">
                                        <Icon icon="tabler:user" class="w-6 h-6" />
                                    </div>
                                    <h2 class="text-lg font-bold text-slate-800 dark:text-white">Datos Personales</h2>
                                </div>

                                <div class="space-y-4 text-sm text-slate-600 dark:text-slate-350">
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Documento</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.person.id_type_document ? typeDocuments.find(item => item.id === object.person.id_type_document)?.label : 'DNI' }}: {{ object.person.num_doc || '-' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Género</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.person.sexo ? 'Masculino' : 'Femenino' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Fecha de Nacimiento</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.person.fecha_nacimiento || '-' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Distrito Nacimiento</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.person.id_distrito_nacimiento ? distritos.find(item => item.id === object.person.id_distrito_nacimiento)?.label : '-' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Teléfono Fijo</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.person.telefono || '-' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Celular</span>
                                        <div class="flex items-center gap-2">
                                            <span class="font-medium text-slate-800 dark:text-white">{{ object.person.celular || '-' }}</span>
                                            <a v-if="object.person.celular"
                                               :href="'https://wa.me/51' + object.person.celular + '?text=Hola'"
                                               target="_blank"
                                               class="p-1 rounded-lg bg-emerald-50 hover:bg-emerald-100 text-emerald-600 dark:bg-emerald-950/20 dark:text-emerald-400 transition-colors"
                                               title="Enviar WhatsApp">
                                                <Icon icon="tabler:brand-whatsapp" class="w-4 h-4" />
                                            </a>
                                        </div>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Email Personal</span>
                                        <span class="font-medium text-slate-850 dark:text-white break-all text-right">{{ object.person.email || '-' }}</span>
                                    </div>
                                    <div class="py-1">
                                        <span class="font-semibold text-slate-400 block mb-1">Domicilio</span>
                                        <span class="font-medium text-slate-800 dark:text-white block">
                                            {{ object.person.domicilio || '-' }}
                                            <span v-if="object.person.id_distrito_domicilio" class="text-slate-400 text-xs block">
                                                Distrito: {{ distritos.find(item => item.id === object.person.id_distrito_domicilio)?.label }}
                                            </span>
                                        </span>
                                    </div>
                                    <div class="py-1">
                                        <span class="font-semibold text-slate-400 block mb-1">Referencia</span>
                                        <span class="font-medium text-slate-800 dark:text-white block bg-slate-50 dark:bg-slate-950 p-2.5 rounded-xl border border-slate-100/50 dark:border-slate-850/50 text-xs">
                                            {{ object.person.referencia || 'Sin referencia' }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Card 2: Información Laboral & Financiera -->
                            <div v-if="$page.props.auth.user.id_rol <= 3" class="bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-3xl shadow-sm p-6 space-y-6">
                                <div class="flex items-center gap-3 border-b border-slate-100 dark:border-slate-800 pb-3">
                                    <div class="p-2 bg-emerald-50 dark:bg-emerald-950/30 rounded-xl text-emerald-600 dark:text-emerald-400">
                                        <Icon icon="tabler:briefcase" class="w-6 h-6" />
                                    </div>
                                    <h2 class="text-lg font-bold text-slate-800 dark:text-white">Datos Laborales y Finanzas</h2>
                                </div>

                                <div class="space-y-4 text-sm text-slate-600 dark:text-slate-350">
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Tipo de Colaborador</span>
                                        <span class="px-2 py-0.5 rounded-md text-xs font-bold uppercase"
                                              :class="object.empleado ? 'bg-indigo-100 text-indigo-800 dark:bg-indigo-950/30 dark:text-indigo-400' : 'bg-amber-100 text-amber-800 dark:bg-amber-950/30 dark:text-amber-400'">
                                            {{ object.empleado ? 'Empleado' : 'Externo / Tercero' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Situación Educativa</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.id_situation_education ? situationeducations.find(item => item.id === object.id_situation_education)?.label : '-' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Inicio de labores</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.fecha_inicio_laboral || '-' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Tipo de Jornal</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.tipo_jornal === 1 ? 'Completo (30 días)' : object.tipo_jornal === 2 ? 'Parcial (Días laborados)' : '-' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Turno Asignado</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.collaboratorturns?.label || '-' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">AFP</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.id_afp ? afps.find(item => item.id === object.id_afp)?.label : '-' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Cuenta Bancaria</span>
                                        <span class="font-medium text-slate-800 dark:text-white break-all text-right">{{ object.cuenta_bancaria || '-' }}</span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Seguro de Salud</span>
                                        <span class="font-medium text-slate-800 dark:text-white">{{ object.seguro || '-' }}</span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Sede de Origen</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.sede_origen && sedes ? (Array.isArray(sedes) ? (sedes.find(s => s.id == object.sede_origen)?.label || object.sede_origen) : (sedes[object.sede_origen] || object.sede_origen)) : 'Todas / No asignada' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400 text-base">Salario Mensual</span>
                                        <span class="font-bold text-lg text-emerald-600 dark:text-emerald-400">
                                            S/. {{ parseFloat(object.salario || 0).toFixed(2) }}
                                        </span>
                                    </div>
                                    <div class="py-1">
                                        <span class="font-semibold text-slate-400 block mb-1">Recursos Prestados</span>
                                        <span class="font-medium text-slate-800 dark:text-white block bg-slate-50 dark:bg-slate-950 p-2.5 rounded-xl border border-slate-100/50 dark:border-slate-850/50 text-xs">
                                            {{ object.recurso_prestado || 'Ninguno' }}
                                        </span>
                                    </div>
                                    <div class="py-1">
                                        <span class="font-semibold text-slate-400 block mb-1">Notas / Observaciones</span>
                                        <span class="font-medium text-slate-800 dark:text-white block bg-slate-50 dark:bg-slate-950 p-2.5 rounded-xl border border-slate-100/50 dark:border-slate-850/50 text-xs whitespace-pre-line">
                                            {{ object.note || 'Sin observaciones' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Fallback for Non-Admins: Laboral details without financial info -->
                            <div v-else class="bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-3xl shadow-sm p-6 space-y-6">
                                <div class="flex items-center gap-3 border-b border-slate-100 dark:border-slate-800 pb-3">
                                    <div class="p-2 bg-emerald-50 dark:bg-emerald-950/30 rounded-xl text-emerald-600 dark:text-emerald-400">
                                        <Icon icon="tabler:briefcase" class="w-6 h-6" />
                                    </div>
                                    <h2 class="text-lg font-bold text-slate-800 dark:text-white">Datos Laborales</h2>
                                </div>

                                <div class="space-y-4 text-sm text-slate-600 dark:text-slate-350">
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400 font-semibold text-slate-400">Tipo de Colaborador</span>
                                        <span class="px-2 py-0.5 rounded-md text-xs font-bold uppercase"
                                              :class="object.empleado ? 'bg-indigo-100 text-indigo-800 dark:bg-indigo-950/30 dark:text-indigo-400' : 'bg-amber-100 text-amber-800 dark:bg-amber-950/30 dark:text-amber-400'">
                                            {{ object.empleado ? 'Empleado' : 'Externo / Tercero' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Puesto Laboral</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.id_puesto_laboral ? puestolaborales.find(item => item.id === object.id_puesto_laboral)?.label : '-' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Turno Asignado</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.collaboratorturns?.label || '-' }}
                                        </span>
                                    </div>
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Inicio de labores</span>
                                        <span class="font-medium text-slate-800 dark:text-white">
                                            {{ object.fecha_inicio_laboral || '-' }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Card 3: Cuenta & Acceso al Sistema -->
                            <div class="bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-3xl shadow-sm p-6 space-y-6">
                                <div class="flex items-center gap-3 border-b border-slate-100 dark:border-slate-800 pb-3">
                                    <div class="p-2 bg-indigo-50 dark:bg-indigo-950/30 rounded-xl text-indigo-600 dark:text-indigo-400">
                                        <Icon icon="tabler:shield-lock" class="w-6 h-6" />
                                    </div>
                                    <h2 class="text-lg font-bold text-slate-800 dark:text-white">Acceso al Sistema</h2>
                                </div>

                                <div class="space-y-4 text-sm text-slate-600 dark:text-slate-350">
                                    <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                        <span class="font-semibold text-slate-400">Acceso a Login</span>
                                        <span class="px-2 py-0.5 rounded-md text-xs font-bold uppercase"
                                              :class="user?.status ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950/30 dark:text-emerald-400' : 'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-400'">
                                            {{ user?.status ? 'Habilitado' : 'Deshabilitado' }}
                                        </span>
                                    </div>
                                    <div v-if="user" class="space-y-4">
                                        <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                            <span class="font-semibold text-slate-400">Usuario Login</span>
                                            <span class="font-medium text-slate-800 dark:text-white">{{ user.user || '-' }}</span>
                                        </div>
                                        <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                            <span class="font-semibold text-slate-400">E-mail de Acceso</span>
                                            <span class="font-medium text-slate-850 dark:text-white break-all text-right">{{ user.email || '-' }}</span>
                                        </div>
                                        <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                            <span class="font-semibold text-slate-400">Rol del Sistema</span>
                                            <span class="font-medium text-slate-800 dark:text-white">
                                                {{ user.id_rol ? roles.find(item => item.id === user.id_rol)?.label : 'Sin Rol' }}
                                            </span>
                                        </div>
                                        <!-- <div class="flex justify-between items-center py-1 border-b border-slate-50 dark:border-slate-850">
                                            <span class="font-semibold text-slate-400">Ver Cursos Formación</span>
                                            <span class="font-medium text-slate-800 dark:text-white">
                                                {{ user.view_course_formacion ? 'Sí' : 'No' }}
                                            </span>
                                        </div> -->
                                    </div>
                                    <div v-else class="text-center py-4 bg-slate-50 dark:bg-slate-950 rounded-2xl border border-dashed border-slate-200 dark:border-slate-800 text-slate-400 text-xs">
                                        No se ha creado una cuenta de usuario para este colaborador.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- Editar -->
                <template v-else-if="action == 'edit'">
                    <div class="grid grids-col-1 bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-3xl shadow-sm p-6 space-y-6">
                        <h2 class="mb-3 text-lg font-bold text-slate-800 dark:text-white">Modificar datos</h2>
                        <form @submit.prevent="submit">
                            <FormField label="Apellidos y Nombres" required>
                                <FormControl v-model="form.apellidos" type="text" required placeholder="Apellidos" :readonly="!isAdmin" />
                                <FormControl v-model="form.nombres" type="text" required placeholder="Nombres" :readonly="!isAdmin" />
                                <FormControl v-model="form.sexo" type="select" :options="optionsGenero" placeholder="Género" :class="!isAdmin ? 'pointer-events-none' : ''" />
                            </FormField>
                            <FormField label="Email/ Documento" required>
                                <FormControl v-model="form.email" type="email" :icon="mdiMail" placeholder="Email" required :readonly="!isAdmin" />
                                <FormControl v-model="form.id_type_document" type="select" :options="typeDocuments" :class="!isAdmin ? 'pointer-events-none' : ''" />
                                <FormControl v-model="form.num_doc" type="text" required :readonly="!isAdmin" />
                            </FormField>
                            <FormField label="Información de contacto/Nacimiento">
                                <FormControl v-model="form.telefono" type="tel" placeholder="Teléfono fijo" />
                                <FormControl v-model="form.celular" type="tel" placeholder="Celular" />
                                <FormControl v-model="form.fecha_nacimiento" type="date" />
                                <FormControl v-model="form.id_distrito_nacimiento" type="select" :options="distritos" placeholder="Distrito de nacimiento" />
                            </FormField>
                            <FormField label="Domicilio">
                                <FormControl v-model="form.domicilio" type="text" placeholder="Dirección" />
                                <FormControl v-model="form.id_distrito_domicilio" type="select" :options="distritos" placeholder="Distrito" />
                                <FormControl v-model="form.referencia" type="text" placeholder="Referencia de domicilio" />
                            </FormField>

                            <!-- Datos de colaborador -->
                            <template v-if="$page.props.auth.user.id_rol <= 3"><!-- Sólo adminsitradores -->
                                <FormField label="Datos de la vivienda/Situación educativa" :help="form.vivienda = selectVivienda + ' :' + textVivienda" required>
                                    <FormControl v-model="selectVivienda" type="select" :options="optionsVivienda" placeholder="Tipo de vivienda" />
                                    <FormControl v-model="textVivienda" type="text" placeholder="Información adicional" />
                                    <FormControl v-model="form.id_situation_education" type="select" :options="situationeducations" placeholder="Situación educativa" required />

                                </FormField>
                                <FormField label="Recurso prestado">
                                    <FormControl v-model="form.recurso_prestado" type="text" labelinput="Algún recurso prestado por la institución" tooltipcontent="ejem. laptop, impresora, etc." />
                                </FormField>

                                <FormField label="Fecha inicio de labores/Puesto laboral/Afp">
                                    <FormControl v-model="form.fecha_inicio_laboral" type="date" />
                                    <FormControl v-model="form.id_puesto_laboral" type="select" :options="puestolaborales" placeholder="Puesto laboral" />
                                    <FormControl v-model="form.id_afp" type="select" :options="afps" placeholder="AFP" />

                                </FormField>

                                <FormField label="Seguro de salud/Cuenta Bancaria" :help="form.seguro = selectSeguroSalud + ' :' + textSeguroSalud">
                                    <FormControl v-model="selectSeguroSalud" type="select" :options="optionsSeguroSalud" />
                                    <FormControl v-model="textSeguroSalud" type="text" :placeholder="selectSeguroSalud == optionsSeguroSalud[0] ? 'Dónde?' : 'Información opcional del seguro'" />
                                    <FormControl v-model="form.cuenta_bancaria" type="text" placeholder="Cuenta bancaria" />
                                </FormField>
                                <FormField label="Nota">
                                    <FormControl v-model="form.note" type="textarea" />
                                </FormField>
                            </template>

                            <FormField label="Datos de Login">
                                <FormControl v-model="form.user_status" type="yesno" labelinput="Acceso al sistema?" placeholder="tiene acceso" tooltipcontent="Por defecto el usuario es el correo y el password es el documento" />
                                <FormControl v-if="form.user_status == 1" v-model="form.id_rol" type="select" :options="roles" labelinput="Rol de usuario" tooltipcontenthtml="
                                            <p>
                                                <strong>Gerencial TI</strong> : Para los gerentes, promotores con acceso a todo<br>
                                                <strong>Administrador</strong> : Para los adminsitradores de sistemas y finanzas con acceso a todo, ver, modificar y crear<br>
                                                <strong>AdminCoord</strong> : Asistente administrativo o coordinadores con privilegios elevados, puede crear y modificar datos<br>
                                                <strong>Coordinador</strong> : Tiene acceso a sólo ver la lista de estudiantes y sus fichas<br>
                                                <strong>Secretaria</strong> : Tiene acceso a sólo ver la lista de estudiantes y sus fichas<br>
                                                <strong>Maestro</strong> : Tiene acceso a sólo ver las aulas asignadas y los estudiantes de estas, ver, crear y modificar las tareas según su curso asignado<br>
                                                <strong>Diseñador</strong> : Tiene acceso a sólo ver, crear y modificar las guías de estudio<br>
                                                <strong>Tutor</strong> : Tiene acceso a sólo ver las aulas asignadas y los estudiantes de estas, ver, crear y modificar las tareas de todos los cursos
                                            </p>
                                            " />
                                <!-- <FormControl v-if="form.user_status == 1" v-model="form.view_course_formacion" type="yesno" labelinput="¿Ver cursos de formación?" tooltipcontent="Habilita al colaborador para acceder al área de cursos de formación" /> -->
                                <!--  -->
                                <FormControl v-model="form.change_password" type="yesno" labelinput="Cambiar email y password por defecto?" tooltipcontent="Por defecto el usuario es el correo y el password es el documento, esto para restablecer los valores de acceso iniciales" />

                            </FormField>
                            <template v-if="$page.props.auth.user.id_rol <= 4"><!-- Admin y AdminCoord -->
                                <FormField label="Estado Empleado">
                                    <FormControl v-model="form.status" type="yesno" labelinput="Empleado activo" placeholder="" tooltipcontent="Si el colaborador está trabjando actualmente" />
                                    <FormControl v-model="form.empleado" type="yesno" labelinput="¿Es empleado?" placeholder="" tooltipcontent="Determina si este colaborador es contratado como empleado de la institución" />
                                    <FormControl v-if="entidades.length > 1" v-model="form.entity" type="select" :options="entidades" labelinput="Entidad" placeholder="" tooltipcontent="Empresa a la que tiene contrato" />
                                    <FormControl v-model="form.sede_origen" type="select" :options="sedes" labelinput="Sede de Origen" placeholder="Sede de Origen" tooltipcontent="Sede a la que pertenece el colaborador para alcance de finanzas y alumnos" />
                                    <FormControl v-if="confGlobal.value.SEDE_EXTERNA_ACTIVAR_COMUNICACION == 1 && $page.props.auth.user.id_rol <= 2" v-model="form.enable_token" type="yesno" labelinput="Crear Token" tooltipcontent="El token es para la comunicación con otras plataformas/sedes, no marcar esto si no está seguro de lo que está haciendo" />
                                </FormField>
                            </template>

                            <template v-if="$page.props.auth.user.id_rol <= 3"><!-- Admins -->
                                <FormField label="Financiero">
                                    <FormControl v-model="form.salario" type="text" labelinput="Salario" tooltipcontent="Salario mensual" />
                                    <FormControl v-model="form.tipo_jornal" type="select" :options="optionsJornal" labelinput="Tipo Turno" placeholder="" tooltipcontent="Para el cálculo de descuento. Tipo completo días por 30, tipo parcial días laborables" />
                                </FormField>
                            </template>

                            <div class="flex items-center justify-end mt-4">
                                <!--<Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Already registered?
                                            </Link>-->
                                <!-- <BreezeButton @click="(action='view')" class="ml-4">
                                                Cancelar
                                            </BreezeButton> -->
                                <Link :href="route('collaborator-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                </Link>

                                <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                    Actualizar
                                </BreezeButton>
                            </div>
                        </form>
                    </div>
                </template>
                <!-- Crear -->
                <template v-else-if="action == 'create'">
                    <div class="grid grids-col-1 bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-3xl shadow-sm p-6 space-y-6">
                        <h2 class="mb-3 text-lg font-bold text-slate-800 dark:text-white">Agregar nuevo colaborador</h2>
                        <form @submit.prevent="submit">
                            <FormField label="Apellidos y Nombres" required>
                                <FormControl v-model="form.apellidos" type="text" required placeholder="Apellidos" />
                                <FormControl v-model="form.nombres" type="text" required placeholder="Nombres" />
                                <FormControl v-model="form.sexo" type="select" :options="optionsGenero" placeholder="Género" />
                            </FormField>
                            <FormField label="Email/ Documento" required>
                                <FormControl v-model="form.email" type="email" :icon="mdiMail" placeholder="Email" required />
                                <FormControl v-model="form.id_type_document" type="select" :options="typeDocuments" />
                                <FormControl v-model="form.num_doc" type="text" required />
                            </FormField>
                            <FormField label="Información de contacto/Nacimiento">
                                <FormControl v-model="form.telefono" type="tel" placeholder="Teléfono fijo" />
                                <FormControl v-model="form.celular" type="tel" placeholder="Celular" />
                                <FormControl v-model="form.fecha_nacimiento" type="date" />
                                <FormControl v-model="form.id_distrito_nacimiento" type="select" :options="distritos" placeholder="Distrito de nacimiento" />
                            </FormField>
                            <FormField label="Domicilio">
                                <FormControl v-model="form.domicilio" type="text" placeholder="Dirección" />
                                <FormControl v-model="form.id_distrito_domicilio" type="select" :options="distritos" placeholder="Distrito" />
                                <FormControl v-model="form.referencia" type="text" placeholder="Referencia de domicilio" />
                            </FormField>
                            <FormField v-if="$page.props.auth.user.id_rol <= 4" label="Condición y Sede">
                                <FormControl v-model="form.empleado" type="yesno" labelinput="¿Es empleado?" placeholder="" tooltipcontent="Determina si este colaborador es contratado como empleado de la institución" />
                                <FormControl v-model="form.sede_origen" type="select" :options="sedes" labelinput="Sede de Origen" placeholder="Sede de Origen" tooltipcontent="Sede a la que pertenece el colaborador para alcance de finanzas y alumnos" />
                            </FormField>



                            <!-- Datos de colaborador -->
                            <!-- <FormField label="Datos de la vivienda/Situación educativa" :help="form.vivienda = selectVivienda + ' : ' + textVivienda" required>
                                            <FormControl v-model="selectVivienda" type="select" :options="optionsVivienda" placeholder="Tipo de vivienda"/>
                                            <FormControl v-model="textVivienda" type="text" placeholder="Información adicional"/>
                                            <FormControl v-model="form.id_situation_education" type="select" :options="situationeducations" placeholder="Situación educativa" required/>
                                            <FormControl v-model="form.recurso_prestado" type="text" labelinput="Recurso prestado" tooltipcontent="Algún recurso prestado por la institución (laptop, impresora, etc)"/>
                                        </FormField>

                                        <FormField label="Fecha inicio de labores/Puesto laboral/Afp" >
                                            <FormControl v-model="form.fecha_inicio_laboral" type="date" />
                                            <FormControl v-model="form.id_puesto_laboral" type="select" :options="puestolaborales" placeholder="Puesto laboral" />
                                            <FormControl v-model="form.id_afp" type="select" :options="afps" placeholder="AFP" />
                                            <FormControl v-model="form.note" type="text" labelinput="Nota adicional" tooltipcontent="Cualquier otra información"/>
                                        </FormField> -->

                            <!-- <FormField label="Seguro de salud/Cuenta Bancaria" :help="form.seguro = selectSeguroSalud + ' : ' + textSeguroSalud">
                                            <FormControl v-model="selectSeguroSalud" type="select" :options="optionsSeguroSalud"/>
                                            <FormControl v-model="textSeguroSalud" type="text" :placeholder="selectSeguroSalud == optionsSeguroSalud[0] ? 'Dónde?' : 'Información opcional del seguro'"/>
                                            <FormControl v-model="form.cuenta_bancaria" type="text" placeholder="Cuenta bancaria"/>
                                        </FormField> -->

                            <!-- <FormField label="Datos de Login">
                                            <FormControl v-model="form.user_status" type="yesno" labelinput="Acceso al sistema?" placeholder="tiene acceso" tooltipcontent="Por defecto el usuario es el correo y el password es el documento"/>
                                            <FormControl v-if="form.user_status == 1" v-model="form.id_rol" type="select" :options="roles" labelinput="Rol de usuario" tooltipcontenthtml="
                                            <p>
                                                <strong>Gerencial TI</strong> : Para los gerentes, promotores con acceso a todo.<br>
                                                <strong>Administrador</strong> : Para los adminsitradores de sistemas y finanzas con acceso a todo, ver, modificar y crear.<br>
                                                <strong>AdminCoord</strong> : Asistente administrativo o coordinadores con privilegios elevados, puede crear y modificar datos.<br>
                                                <strong>Coordinador</strong> : Tiene acceso a sólo ver la lista de estudiantes y sus fichas.<br>
                                                <strong>Secretaria</strong> : Tiene acceso a sólo ver la lista de estudiantes y sus fichas.<br>
                                                <strong>Maestro</strong> : Tiene acceso a sólo ver las aulas asignadas y los estudiantes de estas, ver, crear y modificar las tareas según su curso asignado.<br>
                                                <strong>Diseñador</strong> : Tiene acceso a sólo ver, crear y modificar las guías de estudio.
                                               
                                            </p>
                                            " />
                                        </FormField> -->

                            <div class="flex items-center justify-end mt-4">

                                <!-- <Link :href="route('student')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Volver al listado
                                            </Link> -->
                                <!-- <BaseButton
                                                color="contrast"
                                                :href="route('student')"
                                                small
                                                label=" Cancelar"
                                                class="ml-4"
                                            /> -->
                                <button v-if="object" @click="action = 'view'" class="ml-4 px-4 py-2 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 font-medium rounded-lg text-sm transition-colors" type="button">
                                    Cancelar
                                </button>
                                <Link v-else :href="route('collaborator-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                </Link>
                                <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                    Registrar
                                </BreezeButton>
                            </div>
                        </form>
                    </div>
                </template>

            </template>
            <template v-else-if="(tab == 1)">
                <div class="grid grids-col-1 bg-white rounded-xl border shadow-lg p-4">
                    <h2 class="mb-3">Maestro - Cursos asignados - {{ object.person.apellidos + ' ' + object.person.nombres }}</h2>
                    <div class="mb-2">
                        Estos son los cursos autorizados para enseñar en la institución
                    </div>
                    <div class="mb-2">

                        <CardBox class="mb-6" has-table>
                                <!-- Tablesingle opciones: checkable -->
                                <TableSingle :debugInertia="debugInertia" modulo="collaborator-course" :src_id="object.id" :data="object.courses" :select1="courses" ruta="collaborator-course" deleteable nosearchable nostatus noupdate showRefresh :actionRefresh="['object', 'collaborator_courses']" />
                        </CardBox>

                    </div>
                </div>
            </template>
            <template v-else-if="(tab == 2)">
                <div class="grid grids-col-1 bg-white rounded-xl border shadow-lg p-4">
                    <h2 class="mb-3">Aulas/Secciones asignadas - {{ object.person.apellidos + ' ' + object.person.nombres }}</h2>
                    <div class="mb-2">
                        Estas son las aulas/secciones que tiene acceso
                        <div v-if="object.person.user && object.person.user.id_rol != 5" class="text-l">
                            <ul>
                            <li> Como profesor podrá tener acceso al área de cursos asignados para enseñar y podrá agregar y modificar datos.</li>
                            <li> Como tutor tendrá acceso a todos los cursos del aula, el área de tutoría es sólo lectura, es decir, no podrá agregar o modificar datos en esta área.</li>
                            <li> Por defecto puede asignar aula/seccion del mismo nivel del curso asignado a enseñar, pero puede mostrar todas las aulas por algún caso particular.</li>
                            </ul>
                        </div>
                        <div v-else class="text-l">
                            <ul>
                            <li> Como coordinador, puede escoger las aulas que le corresponden.</li>
                            <li> Para que el coordinador pueda ver los reportes relacionados al aula Ugel debe asignar también el alcance de esas aulas.</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <CardBox class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <TableSingle :debugInertia="debugInertia" modulo="collaborator-classroom" :src_id="object.id" :data="object.classrooms" :select1="classrooms" :select2="collaborator_courses" :select3="(collabIsCoord ? classroomsTeorico : classrooms_courses)" ruta="collaborator-classroom" deleteable nosearchable nostatus noupdate showRefresh :actionRefresh="['object', 'classrooms_courses']" :isCoord="(object.person.user && object.person.user.id_rol != 5 && object.person.user.id_rol != 12 ? false : true)" /> <!-- Coordinador y Psicologa -->
                        </CardBox>
                    </div>
                </div>
            </template>
            <template v-else-if="(tab == 3 && isAdmin)">
                <div class="grid grids-col-1 bg-white rounded-xl border shadow-lg p-4">
                    <h2 class="mb-3">Turnos de asistencia - {{ object.person.apellidos + ' ' + object.person.nombres }}</h2>
                    <div class="mb-2">
                        <ul>
                            <li>Puede asignar más de un turno de asistencia pero los horarios o días no deben coincidir entre ellas.</li>
                        </ul>
                    </div>
                    <CardBox class="w-full overflow-x-auto" has-table>
                        <!-- Tablesingle opciones: checkable -->
                        <TableSingle :debugInertia="debugInertia" modulo="collaboratorturn-user" :src_id="object.id" :data="object.collaboratorturns" :select1="collaboratorturns" :select2="entidades" ruta="collaborator-turn" deleteable nosearchable nostatus noupdate showRefresh :actionRefresh="['object']" />
                    </CardBox>
                </div>
            </template>
            <template v-else-if="(tab == 4 && ($page.props.auth.user.id_rol <= 3 || ($page.props.auth.collaborator && $page.props.auth.collaborator.right && $page.props.auth.collaborator.right('permisos', 'read')) || $page.props.auth.rights?.is_superadmin || $page.props.auth.rights?.map?.permisos?.read))">
                <div class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-md p-6 space-y-6">
                    <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-4">
                        <div class="flex items-center gap-3">
                            <div class="p-2.5 bg-indigo-50 dark:bg-indigo-950/30 rounded-2xl text-indigo-600 dark:text-indigo-400">
                                <Icon icon="tabler:shield-lock" class="w-6 h-6" />
                            </div>
                            <div>
                                <h2 class="text-xl font-bold text-slate-850 dark:text-white">Configuración de Permisos</h2>
                                <p class="text-sm text-slate-500 dark:text-slate-450">
                                    Los permisos activos por el <strong class="text-indigo-600 dark:text-indigo-400">Rol</strong> del colaborador se muestran marcados y bloqueados. Puede añadir permisos individuales adicionales.
                                </p>
                            </div>
                        </div>

                        <div class="hidden sm:flex items-center gap-4 text-xs">
                            <div class="flex items-center gap-1.5 text-slate-500 dark:text-slate-400">
                                <span class="w-3 h-3 rounded bg-indigo-200 dark:bg-indigo-900/60 border border-indigo-400"></span>
                                <span>Heredado de Rol (Bloqueado)</span>
                            </div>
                            <div class="flex items-center gap-1.5 text-slate-500 dark:text-slate-400">
                                <span class="w-3 h-3 rounded bg-indigo-600"></span>
                                <span>Permiso Individual</span>
                            </div>
                        </div>
                    </div>

                    <form @submit.prevent="saveRights" class="space-y-6">
                        <!-- Familias de Permisos -->
                        <div
                            v-for="(group, groupKey) in groupedRightsCatalog"
                            :key="groupKey"
                            class="p-5 bg-slate-50 dark:bg-slate-850 rounded-2xl border border-slate-100 dark:border-slate-800 space-y-4"
                        >
                            <div class="flex items-center gap-2 text-indigo-600 dark:text-indigo-400 font-bold">
                                <Icon :icon="group.icon" class="w-5 h-5" />
                                <h3>{{ group.title }}</h3>
                            </div>

                            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                                <label
                                    v-for="right in group.items"
                                    :key="right.id"
                                    class="flex items-start gap-3 p-3.5 rounded-xl border transition-all select-none"
                                    :class="[
                                        isRoleInheritedRight(right.id)
                                            ? 'bg-slate-100/70 dark:bg-slate-800/40 border-dashed border-indigo-300 dark:border-indigo-800/80 opacity-70 cursor-not-allowed'
                                            : isDirectCheckedRight(right.id)
                                                ? 'bg-indigo-50/50 dark:bg-indigo-950/20 border-indigo-300 dark:border-indigo-800 cursor-pointer shadow-xs'
                                                : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-750 hover:bg-slate-50 dark:hover:bg-slate-850 cursor-pointer'
                                    ]"
                                    :title="isRoleInheritedRight(right.id) ? 'Este permiso ya está activo y garantizado por el Rol de este colaborador.' : ''"
                                >
                                    <input
                                        type="checkbox"
                                        :checked="isRightActive(right.id)"
                                        :disabled="isRoleInheritedRight(right.id)"
                                        @change="toggleDirectRight(right.id)"
                                        class="mt-1 rounded text-indigo-600 focus:ring-indigo-500 w-4 h-4 shrink-0"
                                        :class="isRoleInheritedRight(right.id) ? 'opacity-60 cursor-not-allowed' : ''"
                                    />
                                    <div class="flex-1 min-w-0">
                                        <div class="flex items-center justify-between gap-1">
                                            <span class="text-xs font-bold text-slate-800 dark:text-slate-250">
                                                {{ right.label }}
                                            </span>
                                            <span v-if="isRoleInheritedRight(right.id)" class="text-[9px] font-semibold px-1.5 py-0.2 rounded bg-indigo-100 dark:bg-indigo-900/60 text-indigo-700 dark:text-indigo-300 shrink-0">
                                                Rol
                                            </span>
                                        </div>
                                        <div class="text-[11px] font-mono text-slate-400 dark:text-slate-500 mt-0.5">
                                            {{ right.module }}.{{ right.perms }}
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <!-- Action buttons -->
                        <div class="flex items-center justify-end gap-3 pt-4 border-t border-slate-100 dark:border-slate-800">
                            <Link :href="route('collaborator-list')">
                                <button type="button" class="px-5 py-2.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 font-semibold rounded-xl text-sm transition-colors">
                                    Cancelar
                                </button>
                            </Link>
                            <button
                                type="submit"
                                :disabled="rightsForm.processing"
                                class="px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl text-sm transition-all shadow-md shadow-indigo-600/10 hover:shadow-indigo-600/20 disabled:opacity-50 flex items-center gap-2 cursor-pointer"
                            >
                                <Icon v-if="rightsForm.processing" icon="tabler:loader-2" class="w-4 h-4 animate-spin" />
                                <span>{{ rightsForm.processing ? 'Guardando...' : 'Guardar Permisos' }}</span>
                            </button>
                        </div>
                    </form>
                </div>
            </template>
            <template v-else-if="(tab == 5)">
                <div class="grid grids-col-1 bg-white rounded-xl border shadow-lg p-4">
                    <h2 class="mb-3">Histórico de notas</h2>
                    <div class="grid grid-cols-1 gap-6 mb-6">
                        <div class="flex flex-col"><!-- LRR justify-between para dos áreas con el mimos ancho o no se -->
                            <!--:date="client.created"-->
                            <!--{{ object.ciclos }} object.person.id_distrito_domicilio ? distritos.find(item => item.id === object.person.id_distrito_domicilio ).label : ''-->

                            <div v-for="(ciclo, index) in object.ciclos" :key="ciclo.id"> Año escolar {{ ciclo.anio }}
                                <button @click="showNotas[index] = !showNotas[index]" type="button">Mostrar / ocultar</button>
                                <div v-if="showNotas[index] == true">
                                    <CardBoxCiclo v-for="cursodeciclo in ciclo.ciclodets" :key="cursodeciclo.id" :cursos="cursos" :curso="cursodeciclo.id_course" :asistencia="parseInt(cursodeciclo.asistencia)" :participacion="parseInt(cursodeciclo.participacion)" :tarea="parseInt(cursodeciclo.tarea)" :conducta="parseInt(cursodeciclo.conducta)" :examen_parcial="parseInt(cursodeciclo.examen_parcial)" :examen_parcial2="parseInt(cursodeciclo.examen_parcial2)" :examen_final="parseInt(cursodeciclo.examen_final)" :label="cursodeciclo.label" :progress="parseInt(cursodeciclo.promedio)" />
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="(tab == 10)">
                <div class="grid grids-col-1 bg-white rounded-xl border shadow-lg p-4">
                    <h2 class="mb-3">Agenda</h2>
                    <!-- Documentación: https://antoniandre.github.io/vue-cal/?ref=madewithvuejs.com -->
                    <!-- Ejemplo: https://codepen.io/antoniandre/pen/jJbygw?editors=1010 -->
                    <!-- If the container has no height, set a height on vue-cal -->
                    <div>
                        <VueCal :time="false" locale="es" :disable-views="['years', 'year']" :events="events" />
                    </div>
                </div>
            </template>
        </div>



    </BreezeAuthenticatedLayout>
</template>
